import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const OutsideContributor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M7.5 2C6.39543 2 5.5 2.89543 5.5 4V7C5.5 8.10457 6.39543 9 7.5 9H9.5C10.6046 9 11.5 8.10457 11.5 7V4C11.5 2.89543 10.6046 2 9.5 2H7.5ZM9.5 4H7.5V7H9.5V4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.5 23C20.5376 23 23 20.5376 23 17.5C23 14.4624 20.5376 12 17.5 12C14.4624 12 12 14.4624 12 17.5C12 20.5376 14.4624 23 17.5 23ZM15.5 16H18.293L14.6465 19.6465L15.3536 20.3536L19 16.7072V19.5H20V15H15.5V16Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M2 13C2 11.8954 2.89543 11 4 11H13C13.6154 11 14.1659 11.278 14.5328 11.7152C13.8884 12.0464 13.3065 12.4822 12.8096 13H4V17H2V13Z"
      fill="currentColor"
    />
  </Icon>
));

export default OutsideContributor;
